import React from "react";
import DotGridBackground from "./components/DotGridBackground";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Achievements from "./components/Achievements";
import Contact from "./components/Contact";



import Dock from "./components/Dock";
import ThemeToggle from "./components/ThemeToggle";

import { FaHome, FaGithub, FaLinkedin, } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa";
import { MdEmail } from "react-icons/md";


export default function App() {
  const items = [
  { 
    icon: <FaHome size={18} />, 
    label: "Home", 
    onClick: () => window.scrollTo({ top: 0, behavior: "smooth" }) 
  },

  { 
    icon: <FaGraduationCap size={18} />, 
    label: "Education", 
    onClick: () => document.getElementById("education")?.scrollIntoView({ behavior: "smooth" })
  },

  { 
    icon: <FaGithub size={18} />, 
    label: "GitHub", 
    onClick: () => window.open("https://github.com/Parthistark23", "_blank") 
  },

  { 
    icon: <FaLinkedin size={18} />, 
    label: "LinkedIn", 
    onClick: () => window.open("https://www.linkedin.com/in/parthibarajan001/", "_blank") 
  },

  { 
    icon: <MdEmail size={18} />, 
    label: "Contact", 
    onClick: () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
  },

  { icon: <ThemeToggle />, label: "Theme", onClick: () => {} },
];


  return (
    <div className="min-h-screen relative overflow-hidden bg-white dark:bg-[#060010] text-black dark:text-white">
      {/* DOT GRID (background layer) */}
      <DotGridBackground />

      {/* overlay ABOVE dots but BELOW content (important!) */}
      <div className="absolute inset-0 z-[1] bg-white/20 dark:bg-black/20 pointer-events-none" />

      {/* Content ABOVE everything */}
      <div className="relative z-10 pb-40">
        <Hero />
        <About />
        <Education/>
        <Skills/>
        <Projects/>
        <Achievements/>
        <Contact/>
      </div>

      {/* Dock Navbar */}
      <Dock items={items} />
    </div>
  );
}
